import type {
  CurrencyNumberInputFieldOnBlur,
  CurrencyNumberInputFieldOnChange,
  CurrencyNumberInputFieldOnFocus,
  CurrencyNumberInputFieldViewModel,
  OptionViewModel,
  OptionOnPress,
  AccaInsuranceViewModel,
  PromoButtonCallbacks,
  PromoButtonViewModel,
  GenerosityIconName,
  KeyboardSeparator as WallKeyboardSeparator,
  HintType as WallHintType,
} from "@ppb/the-wall-common/types";
import type { AlertOnClose } from "@ppb/the-wall-common/types/Alert.types";
import type { OddsMovementDirection } from "../../../../store/state/betslip-module/betslip-module.types";

export type BetControlsProps = {
  id: string;
  betType?: string;
  odds?: string;
  oddsAccessibilityLabel?: string;
  oddsLabel?: string;
  stake?: number;
  stakeLabel?: string;
  separator?: WallKeyboardSeparator;
  currencySymbol?: string;
  bonusAvailabilityLabel?: string;
  linesLabel?: string;
  formattedOriginalPotentialReturns?: string;
  formattedPotentialReturns?: string;
  returnsLabel: string;
  dividendBetLabel?: string;
  multiplier?: string;
  hasAccaInsurance: boolean;
  hasEachWay: boolean;
  hasGenerosity?: boolean;
  hasStartingPrice?: boolean;
  hasStakeCaret?: boolean;
  startingPriceTitle?: OptionViewModel["title"];
  oddsMovement?: OddsMovementDirection;
  oddsMovementUp?: string;
  oddsMovementDown?: string;
  eachWayTitle?: OptionViewModel["title"];
  eachWaySubtitle?: OptionViewModel["subtitle"];
  accaInsuranceTitle?: AccaInsuranceViewModel["title"];
  accaInsuranceSubtitle?: AccaInsuranceViewModel["subtitle"];
  accaInsuranceTermsLabel?: AccaInsuranceViewModel["termsLabel"];
  accaInsuranceTermsUrl?: AccaInsuranceViewModel["termsUrl"];
  hintMessage?: string;
  hintType?: WallHintType;
  previousOdds?: string;
  isAccaInsuranceReadonly?: AccaInsuranceViewModel["isReadOnly"];
  isAccaInsuranceSelected: AccaInsuranceViewModel["isSelected"];
  isAccaInsuranceDisabled?: AccaInsuranceViewModel["disabled"];
  isEachWayReadonly?: OptionViewModel["isReadOnly"];
  isEachWaySelected?: OptionViewModel["isSelected"];
  isEachWayDisabled?: OptionViewModel["disabled"];
  isPanelDisabled?: boolean;
  isPriceBoostSelected?: PromoButtonViewModel["isSelected"];
  isGenerositySelected?: PromoButtonViewModel["isSelected"];
  isStartingPriceReadonly?: OptionViewModel["isReadOnly"];
  isStartingPriceSelected?: OptionViewModel["isSelected"];
  isStartingPriceDisabled?: OptionViewModel["disabled"];
  isStakeFocused?: boolean;
  isStakeReadonly?: boolean;
  isStakeValid: boolean;
  shouldDisableOnFocusListener?: CurrencyNumberInputFieldViewModel["shouldDisableOnFocusListener"];
  generosityAlertMessage?: string;
  generosityAlertRemoveLabel?: string;
  isGenerosityDisabled?: boolean;
  displayReturns?: boolean;
  generosityIconName?: GenerosityIconName;
  showNativeKeyboard?: boolean;
  i18n?: { currency: string; multiplier: string };
  hasBonusBall?: boolean;
  bonusBallTitle?: OptionViewModel["title"];
  bonusBallSubtitle?: OptionViewModel["subtitle"];
  isBonusBallSelected?: OptionViewModel["isSelected"];
  isBonusBallDisabled?: OptionViewModel["disabled"];
  isBonusBallReadonly?: OptionViewModel["isReadOnly"];
};

export type BetControlsCallbacks = {
  onEachWayPress?: OptionOnPress;
  onAccaInsurancePress?: OptionOnPress;
  onStakeChange?: CurrencyNumberInputFieldOnChange;
  onStakeFocus?: CurrencyNumberInputFieldOnFocus;
  onStakeBlur?: CurrencyNumberInputFieldOnBlur;
  onGenerosityPress?: PromoButtonCallbacks["onPress"];
  onStartingPricePress?: OptionOnPress;
  onGenerosityRemovePress?: AlertOnClose;
  onBonusBallPress?: OptionOnPress;
};

export type BetControlsViewModel = BetControlsProps & BetControlsCallbacks;

export enum AlertType {
  Success = "SUCCESS",
  Warning = "WARNING",
  Error = "ERROR",
  Info = "INFO",
  Neutral = "NEUTRAL",
  Generosity = "GENEROSITY",
  SaferGambling = "SAFER_GAMBLING",
}

export enum HintType {
  Warning = "WARNING",
}

export enum KeyboardSeparator {
  Comma = ",",
  Dot = ".",
}
